/**
 * @author Fernando Ruano
 * @file constants.js
 * @description Patient Constants
 */

// Generic actions
export const GET_ALL_PATIENTS = 'Patient/GET_ALL_PATIENTS';
export const GET_PATIENT_BY_ID = 'Patient/GET_PATIENT_BY_ID';
export const GET_PATIENT_EXTRA_DATA_BY_ID =
  'Patient/GET_PATIENT_EXTRA_DATA_BY_ID';
export const GET_PATIENT_BY_DOCUMENT = 'Patient/GET_PATIENT_BY_DOCUMENT';
export const CREATE_PATIENT = 'Patient/CREATE_PATIENT';
export const CREATE_PATIENT_OKTA = 'Patient/CREATE_PATIENT_OKTA';
export const UPDATE_PATIENT = 'Patient/UPDATE_PATIENT';
export const UPDATE_PATIENT_STATUS = 'Patient/UPDATE_PATIENT_STATUS';
export const DELETE_PATIENT_BY_ID = 'Patient/DELETE_PATIENT_BY_ID';
export const GET_EMAIL_PATIENT_BY_DOCUMENT =
  'Patiens/GET_EMAIL_PATIENT_BY_DOCUMENT';
export const GET_ALL_IDENTIFICATION_TYPES =
  'Patient/GET_ALL_IDENTIFICATION_TYPES';
export const GET_ALL_PATIENT_STATUS = 'Patient/GET_ALL_PATIENT_STATUS';
export const GET_PATIENT_INDICATORS = 'Patient/GET_PATIENT_INDICATORS';
export const GET_EVENTS_BY_PATIENT_ID = 'Patient/GET_EVENTS_BY_PATIENT_ID';
export const GET_FILTER_PATIENTS = 'Patient/GET_FILTER_PATIENTS';
export const GET_PTH_PATIENT = 'Patient/GET_PTH_PATIENT';
export const GET_UPCOMING_VIDEO_CALLS = 'Patient/GET_UPCOMING_VIDEO_CALLS';
export const GET_LAST_APPOINTMENT = 'Patient/GET_LAST_APPOINTMENT';
export const SEND_MASS_INVITATION = 'Patient/SEND_MASS_INVITATION';
export const GET_LIST_PATIENT_M_PROCESSING =
  'Patient/GET_LIST_PATIENT_M_PROCESSING';
export const GET_PATIENT_M_DETAILS = 'Patient/GET_PATIENT_M_DETAILS';
